import React from "react";
import CustomBreadcrumbs from "../../../component/CustomBreadcrumbs";
import { Box } from "@mui/material";
import ProductBarcodeEditForm from "./ProductBarcodeEditForm";
import { Edit, ResourceContextProvider } from "react-admin";
import { useParams } from "react-router-dom";

const ProductBarcodeEdit: React.FC = () => {

    const { productId } = useParams();

    return (
        <ResourceContextProvider value={"product/barcode"}>
            <Edit actions={false}
                        component="div"
                        mutationMode="pessimistic"
                        redirect={`/product/${productId}/show`}
            >
                <Box>
                    <CustomBreadcrumbs title="Edit Barcode" items={[]} />
                    <ProductBarcodeEditForm type="edit" />
                </Box>
            </Edit>
        </ResourceContextProvider>
    );
};

export default ProductBarcodeEdit;
